@if ({
  requisitionDetailsRequest: requisitionDetailsRequest$ | async,
  registerRequisition: registerRequisition$ | async,
  linkedAccounts: linkedAccounts$ | async,
  accountNumbers: accountNumbers$ | async,
  profileInfo: profileInfo$ | async,
  }; as content) {
  @if (!content.requisitionDetailsRequest?.isPristine) {
    @if (!content.requisitionDetailsRequest?.isLoading) {
      @if (!content.requisitionDetailsRequest?.hasError) {
        <div class="container-modal-request-details container-modal-register-details">
          <div class="container-form">
            <p class="h5 title-form">{{ 'approvalspage.modalRegisterDetails.contactInformation' | cxTranslate }}</p>
            <form-contact [form]="profileDetailsForm" [countries$]="countries$"></form-contact>
          </div>
          <div class="container-form m-t-12">
            <p class="h5 title-form">{{ 'approvalspage.modalRegisterDetails.companyWorkAddress' | cxTranslate }}</p>
            <form-address [form]="profileDetailsForm" [countries$]="countries$"></form-address>
          </div>
          <p class="h4 title-out-form">{{ 'approvalspage.modalRegisterDetails.accountDetails' | cxTranslate }}</p>
          @if (content.profileInfo?.billingAddress) {
            <form-account-details [form]="accountDetailsForm" [countries$]="countries$"></form-account-details>
          }
          <div class="container-form m-t-12">
            <p class="h5 title-form">{{ 'approvalspage.modalRegisterDetails.role' | cxTranslate }}</p>
            <form-roles [form]="formRole"></form-roles>
            @if (content.linkedAccounts?.length) {
              <form [formGroup]="formRole">
                <div class="form-group">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" name="agreement" formControlName="agreement" />
                      <span class="form-check-label">{{ 'approvalspage.modalRoleDetails.approvalAffectsAllAccounts' | cxTranslate }}</span>
                    </label>
                  </div>
                  <cx-form-errors [control]="formRole.get('agreement')"></cx-form-errors>
                </div>
              </form>
            }
          </div>
          @if (content.profileInfo?.linkedAccounts) {
            <div class="simple-card border m-t-12">
              <p class="h5 title-form">{{ 'approvalspage.modalRegisterDetails.linkedAccounts' | cxTranslate }}</p>
              <div class="m-t-12">
                <ul class="list inverted">
                  @for (linkedAccount of content.linkedAccounts; track linkedAccount) {
                    <li>{{ linkedAccount }}</li>
                  }
                </ul>
              </div>
            </div>
          }
          @if (content.profileInfo?.accountNumber !== undefined) {
            <div class="container-form m-t-12">
              <p class="h5 title-form">{{ 'approvalspage.modalAccountDetails.requestedAccount' | cxTranslate }}</p>
              <div class="m-t-12">
                <form-account-numbers
                  [form]="formAccountNumber"
                  [accountNumbers]="content.accountNumbers || []"
                  [persistValues]="true"
                  (_onSetAccountNumbers)="setAccountNumbers($event)"
                ></form-account-numbers>
              </div>
            </div>
          }
          @if (content.registerRequisition?.status === REQUEST_STATUS.PENDING && content.profileInfo?.accountNumber === undefined) {
            <div class="simple-card border m-t-20">
              <p class="h5 title-form">{{ 'approvalspage.modalRegisterDetails.linkedAccounts' | cxTranslate }}</p>
              <div class="m-t-12">
                <form-account-numbers
                  [form]="formAccountNumber"
                  [accountNumbers]="content.accountNumbers || []"
                  (_onSetAccountNumbers)="setAccountNumbers($event)"
                ></form-account-numbers>
              </div>
            </div>
          }
          @if (content.registerRequisition?.code && content.registerRequisition?.status) {
            <modal-request-actions
              [code]="content.registerRequisition?.code!"
              [status]="content.registerRequisition?.status!"
              [approvalsDate]="content.registerRequisition?.approvalDate || undefined"
              [approvalsUser]="content.registerRequisition?.approvalUser || undefined"
              [validation]="validation.bind(this)"
              [replyConfig]="replyConfig"
              (_onReply)="reply($event)"
              (_onClose)="close()"
            ></modal-request-actions>
          }
        </div>
      } @else {
        <alert [alert]="alertMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  }
}
